import React, { useState } from "react";
import { Col, Row, Modal } from "react-bootstrap";
import IconWithButton from "../IconWithButton/IconWithButton";
import "../../components/dataEntryDetails/DataEntryDetails.scss";
import { qaReviewEntityProps } from "../../components/dataEntryDetails/DataEntryDetailsDucks";
import {EntityType, EntityTypeId} from "../../models/assessment";

interface IpropType {
    transactionId: string;
    setShowReviewEntityForm: (show: boolean) => void;
    entityTypes: readonly EntityType[];
    annotation: qaReviewEntityProps;
    createQAReviewEntity: (data: qaReviewEntityProps) => void;
    getReviewEntities: (transactionId: string) => void;
    docAIProcessID: string;
}

const AddReviewEntityForm = (props: IpropType) => {
    const [entityType, setEntityType] = useState<EntityTypeId | "">("");

    const onClickSaveIssue = async () => {
        if (!entityType) {
            alert("Please set an entity type.");
        } else {
            //gather the data
            const data: qaReviewEntityProps = {
                docAIProcessId: props.docAIProcessID,
                typeId: entityType,
                documentFilename: props.annotation.documentFilename,
                page: props.annotation.page,
                x1: props.annotation.x1,
                y1: props.annotation.y1,
                x2: props.annotation.x2,
                y2: props.annotation.y2,
                highlightText: props.annotation.highlightText,
                organizationID: props.annotation.organizationID,
                requestBufferID: props.annotation.requestBufferID,
                userId: props.annotation.userId
            };

            //post it
            props.createQAReviewEntity(data);
            props.setShowReviewEntityForm(false);
        }
    };

    return (<Modal className="cancel-dimension complete-transaction-modal" show>
        <div className="alert-container">
            <Modal.Title className="cancel-header">
                <span className="info-icon"></span>
                <span className="cancel-header-text">Add Undetected Entity</span>
            </Modal.Title>
            <Modal.Body style={{paddingLeft: "2em", paddingRight: "2em"}}>
                <Row>
                    <Col>
                        <p>
                            If the Assessment AI did not annotate something it should have,
                            please select the appropriate entity category.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label className="form-label" htmlFor="sensitivity-type">Entity Type</label>
                        <select
                            className="input-field form-control"
                            name="sensitivityType"
                            id="sensitivity-type"
                            title="Entity Type"
                            value={entityType}
                            onChange={ev => setEntityType(ev.target.value as EntityTypeId)}
                        >
                            <option id="SelectSensitivityType" hidden disabled value="">Select Entity Type</option>
                            {props.entityTypes.map(entType => <option
                                key={entType.id}
                                value={entType.id}
                            >
                                {entType.name}
                            </option>)}
                        </select>
                    </Col>
                </Row>
                <Row className="button-align">
                    <Col xs={3} md={3}>
                        <IconWithButton
                            buttonText={"Save"}
                            onButtonClick={onClickSaveIssue}
                            hideArrowIcon={true}
                            isSave={true}
                        />
                    </Col>
                    <Col xs={1} md={1} className="button-position-cancel">
                        <a href="#" onClick={_ev => props.setShowReviewEntityForm(false)} className="modal-cancel">
                            Cancel
                        </a>
                    </Col>
                </Row>
            </Modal.Body>
        </div>
    </Modal>);
}

export default (AddReviewEntityForm);
